if (!customElements.get('elusapps-option-form')) {
  customElements.define('elusapps-option-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.cutid = this.dataset.cut;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      var elem = document.getElementById("elusapps-option-detas");
      var data = elem !== null ? JSON.parse(elem.textContent) : [];
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      const section = this.closest('section');
      if (!section) return;
  
      const productFormSection = section.querySelector('product-form');
      if (!productFormSection) return;

      const productForm = productFormSection.querySelector('form');
      if (!productForm) return;
  
      const formData = new FormData(productForm);

      const product = Object.fromEntries(formData);

      var formElements = document.forms.elusapps_options.elements;
      var arr = [];
      for(var i=0;i < formElements.length;i++) {
        if (formElements[i].classList.contains('elusapps_opt_input') == true ) {
          var t = formElements[i].type;
          var q = 1;
          if (t === "checkbox") {
            if(formElements[i].checked) {
              arr.push({
                "name": formElements[i].name,
                "value": formElements[i].value,
                "title": formElements[i].title,
                "opt_quantity": q
              })
            }
          } else if (t === "radio") {
            if(formElements[i].checked) {
              arr.push({
                "name": formElements[i].name,
                "value": formElements[i].value,
                "title": formElements[i].title,
                "opt_quantity": q
              })
            }
          } else if (t === "text" || t === "textarea" || t === "select" || t === "select-one") {
            if(formElements[i].value !== "") {
              arr.push({
                "name": formElements[i].name,
                "value": formElements[i].value,
                "title": formElements[i].title,
                "opt_quantity": q
              })
            }
          }
        }
      }

      let min = 100;
      let max = 999;
      var code = Math.floor( Math.random() * (max + 1 - min) ) + min;
      if (arr.length > 0) {
        let addData = {
          'items': []
        }
        let properties = {};
        properties['Option Code'] = product.id+'-'+code;

        for(var j=0;j < arr.length;j++) {
          var pquantity = parseInt(document.querySelector('select[name="quantity"]').value);
          var optData = data.find((d) => d.name === arr[j].name);
          var optQuantity = arr[j].opt_quantity * pquantity;
          var opt = {};
          for(var k=0;k < optData.options.length;k++) {
            var option = optData.options[k];
            if (option.value === arr[j].value) {
              opt = option;
            }
          }
          if (opt.product !== undefined) {
            var adata = {
              'id': opt.product.id,
              'quantity': optQuantity,
              'properties': {
                'Type': 'Option',
                'Option Code': product.id+'-'+code
              }
            };
            addData['items'].push(adata);
          }
          properties[arr[j].title] = arr[j].value;
        }

        addData['items'].push({
          'id': product.id,
          'quantity': product.quantity,
          'properties': properties
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(addData)
        })
        .then((response) => response.json())
        .then((response) => {
          window.location = '/cart/';
          return;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.finallyEvent();
        });

      } else {

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.responseEvent(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.finallyEvent();
        });
      }
    }

    responseEvent(response) {
      if (response.status) {
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (this.dataset.cartType == 'page') {
        window.location = '/cart/';
        return;
      }

      window.location = '/cart/';
      return;
    }

    finallyEvent() {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
